module.exports = __webpack_public_path__ + "static/backdrop_1b-197bee3400193119f0494ff4ee56e61b.png";